import React from 'react';
import html from '../assets/html.png';
import css from '../assets/css.png';
import github from '../assets/github.png';
import javascript from '../assets/javascript.png';
import reactImage from '../assets/react.png';
import tailwind from '../assets/tailwind.png';
import material from '../assets/material.png'

const Experience = () => {

  const technologies = [
    {
      id: 1,
      src: html,
      title: 'HTML',
      style: 'shadow-orange-500',
    },
    {
      id: 2,
      src: css,
      title: 'CSS',
      style: 'shadow-blue-500',
    },
    {
      id: 3,
      src: github,
      title: 'GitHub',
      style: 'shadow-gray-400',
    },
    {
      id: 4,
      src: javascript,
      title: 'JavaScript',
      style: 'shadow-yellow-500',
    },
    {
      id: 5,
      src: reactImage,
      title: 'React',
      style: 'shadow-blue-600',
    },
    {
      id: 6,
      src: tailwind,
      title: 'Tailwind',
      style: 'shadow-sky-400',
    },
    {
      id: 7,
      src: material,
      title: 'M UI',
      style: 'shadow-sky-400',
    },
  ]

  return (
    <div name="experience" className='bg-gradient-to-br from-indigo-900 via-black to-black w-full h-screen'>

      <div className='max-w-screen-lg mx-auto p-4 flex flex-col justify-center w-full h-full text-white'>

        <div className='pb-8'>
          <p className='text-4xl font-bold inline border-b-4 border-gray-500'>Experience</p>
          <p className='py-6 tracking-wider'>These are the technologies I've worked with.</p>
        </div>

        
        <div className='w-full grid grid-cols-2 sm:grid-cols-3 gap-8 text-center py-8 px-12 sm:px-0'>

          {/* techs */}
        {
          technologies.map(({id, src, title, style}) => (
            <div key={id} className={`shadow-md hover:scale-105 duration-200 py-2 rounded-lg ${style}`}>
            <img src={src} alt="" className='w-20 mx-auto'/>
            <p className='mt-4 font-semibold'>{title}</p>
          </div>
          ))
        }
          
        </div>

      </div>
    </div>
  )
}

export default Experience